<a
  mat-flat-button
  *ngIf="inputValue"
  class="clear-all link-button"
  (click)="clear()"
  >Clear</a
>
<mat-form-field>
  <input
    matInput
    [(ngModel)]="inputValue"
    (input)="onInputChange($event.target.value)" />
  <mat-label>{{ configuration?.inputLabel }}</mat-label>
  <mat-hint>{{ configuration?.inputHint }}</mat-hint>
</mat-form-field>
